import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { getSummerData } from "@/api/dataAll/monSummer";
import addLinks from "./components/addLinks";
export default {
  name: "montorSummData",
  components: {
    addLinks: addLinks
  },
  mixins: [tabulation],
  props: {
    reqFnt: {
      type: null,
      default: function _default() {
        return getSummerData;
      }
    }
  },
  data: function data() {
    return {
      tableTitle: [],
      value1: "",
      value2: [],
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      echarts: false,
      dates: [],
      new_device_num: [],
      new_account_num: [],
      active_account_num: [],
      day_account: [],
      recharge_account_num: [],
      recharge_account_amount: [],
      pay_account_percent: [],
      pay_account_arpu: [],
      pay_account_arppu: [],
      login_account_num: [],
      adPlacementSingleChoice: true,
      more: true
    };
  },
  created: function created() {
    this.getsearchDate();
  },
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.value2[0] = date;
      this.value2[1] = date;
    },
    searchClick: function searchClick() {
      var _this = this;

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.searchData.kind = 1;
      var searchData = JSON.parse(JSON.stringify(this.searchData));
      searchData.ad_placement = searchData.ad_placement == 'valuets' ? [''] : searchData.ad_placement;
      this.reqLoading = true;
      this.reqFnt(searchData).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg', 'ad_channel', 'ad_placement'];
          _this.tableData = res.data.length ? _this.$utils.dataConversion(res.data, list) : [];

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    advPlacementchange: function advPlacementchange(e) {},
    handleDelete: function handleDelete(id) {
      var _this2 = this;

      this.$confirm(this.$t('confirmDeleteLink'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleLinksList({
                  id: id
                }).then(function (res) {
                  _this2.searchClick();
                });

                _this2.$message({
                  type: "success",
                  message: _this2.$t('deleteSuccessExclamation')
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('idLabel'),
        prop: 'id'
      }, {
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('game'),
        prop: 'game_reveal'
      }, {
        label: this.$t('platform'),
        prop: 'platform_reveal'
      }, {
        label: this.$t('channel'),
        prop: 'channel_reveal'
      }, {
        label: this.$t('pkg'),
        prop: 'pkg_reveal'
      }, {
        label: this.$t('adChannel'),
        prop: 'ad_channel_reveal'
      }, {
        label: this.$t('adPlacement'),
        prop: 'ad_placement_reveal'
      }, {
        label: this.$t('clickActivationRate'),
        prop: 'radio'
      }];
      var data = JSON.parse(JSON.stringify(this.tableData));
      data.map(function (item, index) {
        item.id = index + 1;

        for (var i in item) {
          item[i] = item[i] == '' ? '/' : item[i];
        }
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};